const formLinkCirclePopup = ".wm-formLinkCircle";
const blogContentSection = ".wm-singleBlogPost__content";
const formLinkSection = ".wm-formLinkSection";
const formLinkMobile = ".wm-formLinkMobile";
jQuery(document).on('ready', function () {
    if (jQuery(formLinkCirclePopup).length > 0 && jQuery(formLinkMobile).length > 0) {
        var heightCheck = jQuery(blogContentSection).offset().top - 600;
        var scroll = jQuery(window).scrollTop();
        jQuery(window).on('resize', function () {
            heightCheck = jQuery(blogContentSection).offset().top - 600;
            scroll = jQuery(window).scrollTop();
        });
        if (scroll >= heightCheck && scroll < jQuery(formLinkSection).offset().top) {
            jQuery(formLinkCirclePopup).addClass("-active");
        }
        else {
            jQuery(formLinkCirclePopup).removeClass("-active");
        }
        jQuery(window).on('scroll', function () {
            scroll = jQuery(window).scrollTop();
            if (scroll >= heightCheck && scroll < jQuery(formLinkSection).offset().top - 1100) {
                jQuery(formLinkCirclePopup).addClass("-active");
            }
            else {
                jQuery(formLinkCirclePopup).removeClass("-active");
            }
        });
    }
});
